import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import EnquiryForm from "../components/EnquiryForm";
import MapSection from "../components/MapSection";
import { Reveal } from "../components/Reveal";
import { site } from "../config/site";

const contactCards = [
  {
    icon: Phone,
    label: "Call Us",
    value: site.phoneDisplay,
    href: site.phoneHref,
    testId: "contact-phone",
  },
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: site.phoneDisplay,
    href: site.whatsappUrl,
    testId: "contact-whatsapp",
    external: true,
  },
  {
    icon: MapPin,
    label: "Visit Us",
    value: `${site.addressLine1}, ${site.addressLine2}`,
    href: site.directionsUrl,
    testId: "contact-address",
    external: true,
  },
  {
    icon: Clock,
    label: "Opening Hours",
    value: `${site.hoursDays} · ${site.hoursTime}`,
    testId: "contact-hours",
  },
];

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact Glow & Blow Unisex Salon | Banjara Hills"
        description="Contact Glow & Blow Unisex Salon in Banjara Hills, Hyderabad — call, WhatsApp, get directions or send an appointment enquiry."
      />
      <PageHero
        eyebrow="Contact"
        titleLines={[
          <>Let's Talk</>,
          <>
            About Your <em className="italic text-champagne">Next Look</em>
          </>,
        ]}
        copy="Call, WhatsApp or send us a message — whatever's easiest. We'll help you plan your visit."
      />

      <section className="pb-24 md:pb-32" data-testid="contact-page">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <div className="space-y-4 lg:col-span-5">
            {contactCards.map((c, i) => {
              const inner = (
                <>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-line text-champagne transition-colors group-hover:border-champagne">
                    <c.icon className="h-5 w-5" />
                  </span>
                  <span>
                    <span className="block text-[11px] font-semibold uppercase tracking-[0.2em] text-soften">
                      {c.label}
                    </span>
                    <span className="mt-1 block font-display text-xl font-medium text-ink">
                      {c.value}
                    </span>
                  </span>
                </>
              );
              return (
                <Reveal key={c.testId} delay={i * 0.08}>
                  {c.href ? (
                    <a
                      href={c.href}
                      data-testid={c.testId}
                      {...(c.external
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {})}
                      className="group flex items-center gap-5 border border-line bg-surface p-5 transition-shadow duration-300 hover:shadow-[0_18px_44px_-20px_rgba(23,23,23,0.25)]"
                    >
                      {inner}
                    </a>
                  ) : (
                    <div
                      className="group flex items-center gap-5 border border-line bg-surface p-5"
                      data-testid={c.testId}
                    >
                      {inner}
                    </div>
                  )}
                </Reveal>
              );
            })}
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="border border-line bg-surface p-7 md:p-10">
                <h2 className="font-display text-2xl font-medium text-ink md:text-3xl">
                  Send an Enquiry
                </h2>
                <p className="mt-2 mb-8 text-sm text-soften">
                  Tell us what you're looking for and we'll get back to you.
                </p>
                <EnquiryForm variant="contact" />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="container-x mt-16">
          <MapSection />
        </div>
      </section>
    </>
  );
}
